import React from "react";
import { ProbationFormPanel } from "../components/probation-form-panel.tsx";
import { useUser } from "../../../../lib/rbac/useUser.ts";
import { isSqeLabsEmployeeType } from "../../../../hooks/use-logged-in-employee.ts";
import { sqeEmployeeQuestions } from "../utils/sqe-induction-questions.ts";
import styles from "./probation-assessment-tab.module.css";

interface ProbationAssessmentTabProps {
    cycleId: number;
}

export function ProbationAssessmentTab({ cycleId }: ProbationAssessmentTabProps) {
    const user = useUser();
    const isSqeEmployee = isSqeLabsEmployeeType(user?.empType);

    return (
        <div className={styles.root}>
            <ProbationFormPanel
                cycleId={cycleId}
                sectionType="EMPLOYEE"
                transformQuestions={isSqeEmployee ? sqeEmployeeQuestions : undefined}
                conditionalInductionDuration={isSqeEmployee}
                onSuccess={() => {}}
            />
        </div>
    );
}
